<template>
    <v-responsive fluid v-resize="myEventHandler">
        <div>
            <v-card-title primary-title>
                <v-row dense justify="space-between">
                    <v-col cols="12" sm="8">
                        <div
                            v-if="$vuetify.breakpoint.mdAndDown"
                            :class="`primary--text text-overline ml-2 ${
                                $vuetify.breakpoint.xs ? 'text-center' : ''
                            }`"
                        >
                            Gestión de Tarifas
                        </div>
                        <div
                            v-else
                            class="
                                font-weight-light
                                primary--text
                                text-h4
                                ml-2
                                text-capitalize
                            "
                        >
                            Gestión de Tarifas
                        </div>
                    </v-col>
                    <v-col
                        sm="4"
                        cols="12"
                        :class="`d-flex align-center ${
                            $vuetify.breakpoint.xs
                                ? 'justify-center'
                                : 'justify-end'
                        }`"
                    >
                        <!-- <v-progress-circular
                            width="2"
                            v-if="tariffManagement.isLoading"
                            :size="30"
                            color="black"
                            indeterminate
                        ></v-progress-circular> -->
                        <v-btn
                            @click="openCrossForm()"
                            color="green"
                            class="mr-2"
                            :small="$vuetify.breakpoint.mdAndDown"
                            text
                        >
                            Upfront Cross
                            <v-icon
                                :right="!$vuetify.breakpoint.mdAndDown"
                                :small="$vuetify.breakpoint.mdAndDown"
                            >
                                mdi-pen-plus
                            </v-icon>
                        </v-btn>
                        <v-btn
                            @click="openAddingForm"
                            :small="$vuetify.breakpoint.mdAndDown"
                            color="green"
                            text
                        >
                            Nueva Tarifa
                            <v-icon
                                :right="!$vuetify.breakpoint.mdAndDown"
                                :small="$vuetify.breakpoint.mdAndDown"
                            >
                                mdi-pen-plus
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-title>
            <!-- <v-divider class="test"></v-divider> -->
            <v-data-table
                :height="tableHeight"
                :headers="headers"
                :items="tariffManagement.tariffs"
                :loading="tariffManagement.isLoading"
                :page.sync="page"
                :footer-props="footerProps"
                :server-items-length="totalEntries"
                :options.sync="options"
                :search="search"
                class="px-2"
                hide-default-footer
            >
                <template v-slot:footer="{ props }">
                    <v-data-footer
                        style="height: 60px; justify-content: flex-end"
                        :items-per-page-options="props.itemsPerPageOptions"
                        :options.sync="options"
                        :pagination.sync="props.pagination"
                        show-first-last-page
                    >
                    </v-data-footer>
                </template>
                <template v-slot:item.is_active="{ item }">
                    <v-icon :color="item.is_active ? 'green' : 'red'">
                        mdi-circle
                    </v-icon>
                </template>
                <template v-slot:item.Actions="{ item }">
                    <v-row>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="primary"
                                text
                                @click="watchingForm(item)"
                            >
                                <v-icon> mdi-information-slab-box </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col md="3">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="orange"
                                text
                                @click="editingForm(item)"
                            >
                                <v-icon> mdi-pen </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col v-if="hasSuperAdminPermission" md="2">
                            <v-btn
                                class="d-flex grow justify-center flex-wrap"
                                fab
                                small
                                color="red"
                                text
                                @click="openConfirmdelete(item)"
                            >
                                <v-icon> mdi-delete-empty-outline </v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </template>
            </v-data-table>
            <TariffManagementCrossForm />
        </div>
    </v-responsive>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import TariffManagementCrossForm from '@/components/GerenciaTeletrabajo/Management/TariffManagement/TariffManagementCrossForm.vue';

export default {
    name: 'ManagementBaseTable',
    components: {
        TariffManagementCrossForm,
    },
    data: () => ({
        firstloaded: true,
        tableHeight: 300,
        footerProps: {
            itemsPerPageOptions: [0],
        },
        options: {},

        headers: [
            { text: 'Nombre', value: 'name', sortable: false },
            { text: 'Operador', value: 'operator', sortable: false },
            { text: 'Categoría', value: 'category', sortable: false },
            { text: 'Segmento', value: 'segment', sortable: false },
            { text: 'Precio', value: 'price', sortable: false },
            { text: 'Activa', value: 'is_active', sortable: false },
            {
                text: 'Acciones',
                value: 'Actions',
                align: 'center',
                sortable: false,
                width: '200px',
            },
        ],
    }),
    methods: {
        setForm(item) {
            this.$store.state.ManagementBase.tariffManagement.Upfront =
                item.upfront ? item.upfront.upfront : 0;
            this.$store.state.ManagementBase.tariffManagement.commercial_enrichment =
                item.commercial_enrichment;
            this.$store.state.ManagementBase.tariffManagement.description_file =
                item.description_file;
            this.$store.state.ManagementBase.tariffManagement.isActive =
                item.is_active;
            this.$store.state.ManagementBase.tariffManagement.name = item.name;
            this.$store.state.ManagementBase.tariffManagement.operator =
                item.operator;
            this.$store.state.ManagementBase.tariffManagement.category =
                item.category;

            this.$store.state.ManagementBase.tariffManagement.payment_type =
                item.payment_type;
            this.$store.state.ManagementBase.tariffManagement.segment =
                item.segment;
            this.$store.state.ManagementBase.tariffManagement.color =
                item.color;
            this.$store.state.ManagementBase.tariffManagement.price =
                item.price;
            this.$store.state.ManagementBase.tariffManagement.price_history =
                item.price_history;
            this.$store.state.ManagementBase.tariffManagement.upfront_history =
                item.upfront_history;

            if (
                item.mobile_line_info != null &&
                item.mobile_line_info['voice_to_foreign']
            )
                this.$store.state.ManagementBase.tariffManagement.MobileForeignMinuteQuantity =
                    item.mobile_line_info.voice_to_foreign.amount;

            if (
                item.mobile_line_info != null &&
                item.mobile_line_info['mobile_line_data'] &&
                item.mobile_line_info['mobile_line_voice']
            ) {
                this.$store.state.ManagementBase.tariffManagement.MobileNationalMinuteQuantity =
                    item.mobile_line_info
                        ? item.mobile_line_info.mobile_line_voice.amount
                        : '';
                this.$store.state.ManagementBase.tariffManagement.DataQuantity =
                    item.mobile_line_info
                        ? item.mobile_line_info.mobile_line_data.amount
                        : '';
                this.$store.state.ManagementBase.tariffManagement.DataUnit =
                    item.mobile_line_info
                        ? item.mobile_line_info.mobile_line_data.unit
                        : '';
            }

            if (
                item.fixed_line_info != null &&
                item.fixed_line_info['voice_to_fixed'] &&
                item.fixed_line_info['voice_to_mobile']
            ) {
                this.$store.state.ManagementBase.tariffManagement.Owner =
                    item.fixed_line_info.owners;
                this.$store.state.ManagementBase.tariffManagement.FiberType =
                    item.fixed_line_info.type;
                this.$store.state.ManagementBase.tariffManagement.LandLineToLandLineMinuteQuantity =
                    item.fixed_line_info.voice_to_fixed
                        ? item.fixed_line_info.voice_to_fixed.amount
                        : '';
                this.$store.state.ManagementBase.tariffManagement.LandLineToMobileMinuteQuantity =
                    item.fixed_line_info.voice_to_mobile
                        ? item.fixed_line_info.voice_to_mobile.amount
                        : '';
                this.$store.state.ManagementBase.tariffManagement.UploadSpeedQuantity =
                    item.fixed_line_info.upload_speed
                        ? item.fixed_line_info.upload_speed.amount
                        : '';
                this.$store.state.ManagementBase.tariffManagement.DownloadSpeedQuantity =
                    item.fixed_line_info.download_speed
                        ? item.fixed_line_info.download_speed.amount
                        : '';
                this.$store.state.ManagementBase.tariffManagement.UploadSpeedUnit =
                    item.fixed_line_info.upload_speed
                        ? item.fixed_line_info.upload_speed.unit
                        : '';
                this.$store.state.ManagementBase.tariffManagement.DownloadSpeedUnit =
                    item.fixed_line_info.download_speed
                        ? item.fixed_line_info.download_speed.unit
                        : '';
            }

            this.$store.state.ManagementBase.tariffManagement.SelectedPromotions =
                item.promotions;
            this.$store.state.ManagementBase.tariffManagement.SelectedAditionals =
                item.additional_lines;
            this.$store.state.ManagementBase.tariffManagement.SelectedSVA =
                item.svas;
            this.$store.state.ManagementBase.tariffManagement.editingId =
                item.id;
        },
        openAddingForm() {
            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'TARIFF';
            this.$store.state.ManagementBase.baseForm.formType = 'add';
            this.$store.state.ManagementBase.baseForm.isActive = true;
        },
        openConfirmdelete(item) {
            let deleteData = {
                module: 'ManagementBase/tariffManagement',
                item: item,
            };

            this.$store.commit('ManagementBase/confirmDeletion', {
                val: true,
                deleteData,
            });
        },
        watchingForm(item) {
            this.setForm(item);

            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'TARIFF';
            this.$store.state.ManagementBase.baseForm.formType = 'watch';
            this.$store.state.ManagementBase.baseForm.item_id = item.id;
            this.$store.state.ManagementBase.baseForm.isActive = item.is_active;
        },
        editingForm(item) {
            this.setForm(item);

            this.$store.state.ManagementBase.baseForm.isOpenBaseDialog = true;
            this.$store.state.ManagementBase.baseForm.type = 'TARIFF';
            this.$store.state.ManagementBase.baseForm.formType = 'edit';
            this.$store.state.ManagementBase.baseForm.item_id = item.id;
            this.$store.state.ManagementBase.baseForm.isActive = item.is_active;
        },
        determineWidth() {
            let width = window.innerWidth;
            let height = 0;
            if (this.$vuetify.breakpoint.smAndDown) {
                height = 294;
            } else if (this.$vuetify.breakpoint.mdAndDown) {
                height = 234;
            } else {
                if (width < 1661) {
                    height = 258;
                } else {
                    height = 242;
                }
            }
            return height;
        },
        myEventHandler() {
            // Get width of the window
            this.tableHeight =
                document.getElementById('fullHeigth')?.clientHeight -
                this.determineWidth();
        },
        openCrossForm() {
            this.$store.commit(
                'ManagementBase/tariffManagement/isOpenCrossForm',
                true
            );
        },
        ...mapActions('ManagementBase/tariffManagement', {
            getTariffs: 'getTariffs',
        }),
    },
    computed: {
        page: {
            get() {
                return this.$store.state.ManagementBase.tariffManagement
                    .tariffManagement.page;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/tariffManagement/tariffManagementPage',
                    val
                );
            },
        },
        ...mapState('ManagementBase/tariffManagement', {
            tariffManagement: (state) => state.tariffManagement,
            totalEntries: (state) => state.tariffManagement.totalEntries,
        }),
        ...mapState('ManagementBase', {
            tipoObjetivo: (state) => state.tipoObjetivo,
            loadingItems: (state) => state.loadingItems,
            managementFiltersForm: (state) => state.managementFilters.form,
        }),
        ...mapGetters('login', {
            hasSuperAdminPermission: 'hasSuperAdminPermission',
        }),
        ...mapState('util', {
            search: (state) => state.navBarSearchField,
        }),
    },
    mounted() {},
    watch: {
        options: {
            immediate: false,
            handler() {
                let page = this.options.page;
                if (
                    this.options.page == page &&
                    !this.firstloaded &&
                    !this.tariffManagement.isLoading
                ) {
                    this.$store.dispatch(
                        'ManagementBase/tariffManagement/updateTariffManagementParams',
                        this.options
                    );
                    this.getTariffs();
                }
            },
            // Permite que el handler se ejecute cuando cambie cualquiera de los campos de options
            deep: true,
        },
        managementFiltersForm: {
            deep: true,
            immediate: true,
            handler(val) {
                this.options.page = 1;
                this.$store.dispatch(
                    'ManagementBase/tariffManagement/updateTariffManagementParams',
                    { ...this.managementFiltersForm, page: 1 }
                );

                this.getTariffs();
            },
        },
        search() {
            let text = this.search;
            // Evitar sobre cargas a la API, solo hace la peticion cuando dejas de escribir
            setTimeout(() => {
                if (text == this.search) {
                    this.options.page = 1;
                    this.tariffManagement.page = 1;

                    this.$store.dispatch(
                        'ManagementBase/tariffManagement/updateTariffManagementParams',
                        { search: this.search }
                    );
                    this.getTariffs();
                }
            }, 300);
        },
        tableHeight() {
            this.footerProps.itemsPerPageOptions[0] = Math.floor(
                this.tableHeight / 48 - 1
            );
            this.$store.commit('ManagementBase/itemsPerPage', this.footerProps.itemsPerPageOptions[0]);
            this.options.itemsPerPage = this.footerProps.itemsPerPageOptions[0];
            this.firstloaded = false;
        },
    },
};
</script>

<style>
</style>